module.exports = __webpack_public_path__ + "static/media/bbc_news_live_world-europe-36799172_plot.eb264e47.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/bbc_news_live_world-europe-36799172_plot.png
// module id = 356
// module chunks = 0